import React from 'react';
import { Link } from 'react-router-dom';
import { FaBook, FaTwitter, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center mb-4">
              <FaBook className="w-8 h-8 text-yellow-400 mr-2" />
              <span className="text-xl font-bold">Amalie AI</span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Master languages with AI-powered learning. Interactive lessons, real-time feedback, and personalized practice.
            </p>
            <div className="flex space-x-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <FaTwitter className="w-5 h-5" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <FaFacebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <FaInstagram className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <FaLinkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard" className="text-gray-400 hover:text-white transition-colors">Dashboard</Link>
              </li>
              <li>
                <Link to="/songs" className="text-gray-400 hover:text-white transition-colors">Songs</Link>
              </li>
              <li>
                <Link to="/stories" className="text-gray-400 hover:text-white transition-colors">Stories</Link>
              </li>
              <li>
                <Link to="/videoreel" className="text-gray-400 hover:text-white transition-colors">Videos</Link>
              </li>
              <li>
                <Link to="/exam" className="text-gray-400 hover:text-white transition-colors">Exams</Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/store" className="text-gray-400 hover:text-white transition-colors">Store</Link>
              </li>
              <li>
                <Link to="/coupons" className="text-gray-400 hover:text-white transition-colors">Coupons</Link>
              </li>
              <li>
                <Link to="/wallet" className="text-gray-400 hover:text-white transition-colors">Wallet</Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">Blog</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">Help Center</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">Cookie Policy</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">GDPR Compliance</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>© 2025 Amalie AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}